module.exports = __webpack_public_path__ + "static/media/tree.f6750e35.png";